import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ContentExpansion from "../../../../components/ContentExpansion";
import { SpacerContainer } from "../../../../components/styledComponents/SpacerContainer";
import { berechneErmuedung } from "../../../../services/Inner/berechneErmuedung.service";
import { useGetTraggliedDatenQuery } from "../../../../services/API/titanApi";
import {
  selectFrontendZustand,
  setErmuedungDetails,
} from "../../../../store/slices/frontendZustandSlice";
import {
  selectAnzahlLastwechsel,
  selectSchwingungsObergrenze,
  selectSchwingungsUntergrenze,
  selectTeilsicherheitsbeiwertFuerErmuedung,
  selectTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991,
} from "../../../../store/slices/innereSlice";
import { selectTragglied } from "../../../../store/slices/traggliedSlice";
import CharakteristischeEinwirkungen from "./CharakteristischeEinwirkungen/CharakteristischeEinwirkungen";

export default function Ermudung() {
  const { t } = useTranslation("translation");

  // #region Redux Store Variables
  const tragglied = useSelector(selectTragglied);
  const { ermuedungDetails } = useSelector(selectFrontendZustand);
  const anzahlLastwechsel = useSelector(selectAnzahlLastwechsel);
  const schwingungsObergrenze = useSelector(selectSchwingungsObergrenze);
  const schwingungsUntergrenze = useSelector(selectSchwingungsUntergrenze);
  const teilsicherheitsbeiwertFuerErmuedung = useSelector(
    selectTeilsicherheitsbeiwertFuerErmuedung
  );
  const teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991 = useSelector(
    selectTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991
  );
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  // #endregion

  const [Rd, setRd] = useState();
  const [ausnutzung, setAusnutzung] = useState();
  const [upperLower, setUpperLower] = useState(0);
  const [Rk, setRk] = useState();
  const [calc, setcalc] = useState();

  useEffect(() => {
    let berechneteErmuedungsWerte = berechneErmuedung(
      Number(traggliedDaten?.querschnitt),
      Number(anzahlLastwechsel),
      Number(teilsicherheitsbeiwertFuerErmuedung),
      Number(schwingungsObergrenze),
      Number(schwingungsUntergrenze),
      Number(teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991)
    );

    setRd(berechneteErmuedungsWerte?.Rd);
    setUpperLower(berechneteErmuedungsWerte?.upperLower);
    setAusnutzung(berechneteErmuedungsWerte?.ausnutzungCalc);
    setRk(berechneteErmuedungsWerte?.Rk);
    setcalc(berechneteErmuedungsWerte?.calc);
  }, [
    traggliedDaten,
    anzahlLastwechsel,
    teilsicherheitsbeiwertFuerErmuedung,
    schwingungsObergrenze,
    schwingungsUntergrenze,
    teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991,
    ausnutzung,
  ]);

  return (
    <SpacerContainer>
      <div className="row">
        <ContentExpansion expand={ermuedungDetails} reducer={setErmuedungDetails} />
      </div>

      {ermuedungDetails == false && (
        <div className="box">
          <div className="row">
            <h1>{t("inner.fatigue.headline")}</h1>
          </div>
        </div>
      )}
      <CharakteristischeEinwirkungen
        expand={ermuedungDetails}
        ausnutzung={ausnutzung}
        upperLower={upperLower}
        charakteristischeSchwingbreite={Rk}
        zulaessigeBemessungsschwingbreite={Rd}
        ermudung={calc}
        querschnitt={traggliedDaten?.querschnitt}
      />
    </SpacerContainer>
  );
}
